import { CheckboxProps as MuiCheckboxProps } from '@mui/material/Checkbox';
import { MuiCheckbox } from '../../../../../../modules/material';
import {
  StyledCheckboxControlIcon,
  StyledCheckboxControlCheckedIcon,
} from './styles';

export interface CheckboxControlProps extends MuiCheckboxProps {}

export default function CheckboxControl(props: CheckboxControlProps) {
  return (
    <MuiCheckbox
      checkedIcon={<StyledCheckboxControlCheckedIcon />}
      icon={<StyledCheckboxControlIcon />}
      {...props}
    />
  );
}
